import type { ReceiptTemplate } from '../schema';

export const monsterEnergyTemplate: ReceiptTemplate = {
  id: 'monster-energy',
  name: 'Monster Energy Receipt',
  brand: 'MONSTER ENERGY',
  description: 'Monster Energy store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'me-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MONSTER ENERGY',
        businessNameFontSize: 16,
        addressLines: ['OFFICIAL STORE'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'me-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'ME-847291034' },
          { id: 'customer', label: 'Customer:', value: 'John Doe' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'me-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MONSTER ORIGINAL 4-PACK', quantity: '2', price: '9.99', sku: '' },
          { id: '2', name: 'MONSTER ULTRA 4-PACK', quantity: '1', price: '9.99', sku: '' },
          { id: '3', name: 'MONSTER HOODIE BLACK XL', quantity: '1', price: '45.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'me-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '74.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '6.19', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '81.16', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'me-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'me-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'UNLEASH THE BEAST\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

